import { render, staticRenderFns } from "./RadioBtns.vue?vue&type=template&id=7971f7b0&scoped=true&lang=pug&"
import script from "./RadioBtns.vue?vue&type=script&lang=js&"
export * from "./RadioBtns.vue?vue&type=script&lang=js&"
import style0 from "./RadioBtns.vue?vue&type=style&index=0&id=7971f7b0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7971f7b0",
  null
  
)

export default component.exports